import { selectMessage } from 'redhotpie-shared-lib/actions/conversationDetailAction';
import { Dispatch } from 'redhotpie-shared-lib/hooks/useRedux';
import { IConversation } from 'redhotpie-shared-lib/interfaces/IConversation';
import { IMessage } from 'redhotpie-shared-lib/interfaces/IMessage';
import messageApi from '../api/messageApi';
import urls from '../api/urls';
import * as types from '../constants/actionTypes';
import * as chatTypes from '../constants/chatTypes';
import { TYPE_CHAT, TYPE_GROUP_CHAT } from '../constants/chatTypes';
import {
  CHAT_TYPES,
  CONVERSATION_STATUS,
  MATCHING_DONTMATCHING,
  MSG_TEMPLATE as msgTpl,
  THREE_MONTHS,
  ChatType,
} from '../constants/constants';
import {
  STATE_GROUP_CONFIRMED,
  STATE_GROUP_INVITED,
  STATE_STATUS_ACCEPT,
  STATE_STATUS_DECLINE,
  STATE_STATUS_NULL,
  STATUS_DELETED,
  STATUS_FAIL,
  STATUS_HIDDEN,
  STATUS_OPENED,
  STATUS_READ,
} from '../constants/messageStatus';
import * as messageTypes from '../constants/messageTypes';
import {
  TYPE_FASTEN_DELETE,
  TYPE_GALLERY,
  TYPE_GIF,
  TYPE_SHARE_EVENT_TICKET,
  TYPE_VIDEO_FILE,
  TYPE_AUDIO_FILE,
} from '../constants/messageTypes';
import { TYPE_GIFT, TYPE_INVITE, TYPE_REACTION_MESSAGE, NotificationType, TYPE_MESSAGE } from '../constants/notificationTypes';
import { addPrefixAndSuffix } from '../functions/messageUtils';
import * as utils from '../functions/utils';
import { isVideoFile, isAudioFile } from '../functions/utils';
import WebIM from '../libs/webIM';
import WebIMConfig from '../libs/webIMConfig';
import RecentlySentPhotoModel, { MEDIA_TYPE } from '../models/recentlySentPhotoModel';
import { mappingVideoFile } from '../models/videoFile';
import giftServices from '../services/giftServices';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import * as commonStateActions from './commonStateAction';
import { addUserMediaSuccess } from './commonStateAction';
import * as conversationInboxAction from './conversationInboxAction';
import { notifyMessageSent, notifyMessageSentGroupChat } from './conversationInboxAction';
import { conversationDetailAction } from './index';
import * as messageBufferAction from './messageBufferAction';
import * as userActions from './userActions';
import { duration } from 'moment';
import { ChatStateType } from '../constants/chatStateTypes';

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

interface Message {
  userId: string;
  photoId: string;
  fullUrl: string;
  thumbUrl: string;
}

interface MessageData {
  messageData: any;
  type: string;
}

interface SendMessageOptions {
  notificationType?: NotificationType;
  convId?: number | null;
  expts?: number;
}

type EditTextMessageParams = {
  chatType: 'chat' | 'groupchat';
  chatId: string;
  data: string;
  msgId: string;
  options: {
    isLastedMessage: boolean;
    convId: number;
  };
};

interface SendMessageParams {
  chatType: string;
  chatId: string;
  message?: string;
  senderMemberLevel?: number;
  recvMemberLevel?: number;
  isRecvMatching?: boolean;
  isSenderMatching?: boolean;
  msgId?: string;
  options?: SendMessageOptions;
  galleryData?: string;
  source?: any;
}

function getLoginXmppId(): string {
  const login = myStore.getStore().getState().loginReducer;
  if (login && login.userInfo) {
    return login.userInfo.xmppId;
  }
  return '';
}

function getProfilePhotoComment(): boolean {
  return myStore.getStore().getState().messageReducer.profilePhotoCommentShouldBeSend;
}

function getPeerXmppId(): string {
  const selectedPeerVcard = myStore.getStore().getState().conversationsReducer.selectedPeerVcard;
  return selectedPeerVcard?.xmppId || '';
}

function getPublicGroupChatRooms(): any {
  return myStore.getStore().getState().groupChatReducer.data;
}

function getLoginUserId(): string {
  const login = myStore.getStore().getState().loginReducer;
  if (login && login.userInfo) {
    return login.userInfo.userId;
  }
  return '';
}

export function updateprofilePhotoCommentShouldSend(message: Message | null) {
  return { type: types.UPDATE_PROFILE_PHOTO_MESSAGE, message };
}

export function expireMessage(mid: string) {
  return { type: types.EXPIRE_MESSAGE_SUCCESS, mid };
}

export function updateMessageSent(mid: string) {
  return { type: types.UPDATE_MESSAGE_SENT, mid };
}

export function removeMessage(mid: string) {
  return { type: types.REMOVE_MESSAGE_SUCCESS, mid };
}

export function removeMessageByRoomJid(roomJid: string) {
  return { type: types.REMOVE_MESSAGE_BY_ROOM_JID_SUCCESS, roomJid };
}

export function markExpiredMessageInvitePrivateGroupChat(roomJid: string) {
  return { type: types.MARK_EXPIRED_MESSAGE_INVITE_PRIVATE_GROUP_CHAT, roomJid };
}

export function removeMessageByUserIdAndRoomJid(userId: string, roomJid: string) {
  return {
    type: types.REMOVE_MESSAGE_BY_USER_ID_AND_ROOM_JID_SUCCESS,
    userId,
    roomJid,
  };
}

export function getCurrentSelectedConversationId(): number {
  return myStore.getStore().getState().conversationsReducer.selectedConversationInfo?.id || 0;
}

function getTimeSystem(type: string): number {
  return new Date().getTime() + myStore.getStore().getState().conversationsReducer.chatServerTime;
}

const availableXmppId: string[] = [];

function getUsers(): any[] {
  const { usersReducer } = myStore.getStore().getState();
  if (usersReducer && usersReducer.users) {
    return usersReducer.users;
  }

  return [];
}

function getSelectedPeerVcard(): any {
  return myStore.getStore().getState().conversationsReducer.selectedPeerVcard;
}

export function addMessageToQueueSend({ messageData, type }: MessageData, userId?: string) {
  return (dispatch: any) => {
    const selectedUserId = userId || getSelectedPeerVcard()?.userId;
    if (selectedUserId) {
      dispatch({
        type: types.ADD_MESSAGE_TO_QUEUE_TO_SEND,
        message: { type, data: messageData },
        userId: selectedUserId,
      });
    }
  };
}

export function removeMessageInQueueToSend(userId?: string) {
  return (dispatch: any) => {
    const selectedUserId = userId || getSelectedPeerVcard()?.userId;
    if (selectedUserId) {
      dispatch({
        type: types.REMOVE_MESSAGE_IN_QUEUE_TO_SEND,
        userId: selectedUserId,
      });
    }
  };
}

export function updateDeleteReferenceMessage(mid: string) {
  return (dispatch: any, getState: any) => {
    dispatch({ type: types.UPDATE_DELETE_REFERENCE_MESSAGES, mid });
  };
}

export function updateMessageReducer(data: any) {
  return { type: types.UPDATE_MESSAGE_REDUCER, data };
}

export function updateMessageStatus(mid: string, status: string, peerUserXmppId = '', isLast = false, conversationId = 0) {
  return (dispatch: any) => {
    if (status !== STATUS_DELETED) {
      if (
        status === STATE_GROUP_CONFIRMED ||
        status === STATE_GROUP_INVITED ||
        status === STATUS_OPENED ||
        status === STATE_STATUS_ACCEPT ||
        status === STATE_STATUS_DECLINE
      ) {
        messageApi.updateMessageState(mid, status, addPrefixAndSuffix(peerUserXmppId), isLast, `${conversationId}`).then(res => {});
      } else {
        messageApi
          .updateMessageStatus(
            mid,
            status === STATE_STATUS_NULL ? STATUS_READ : status,
            addPrefixAndSuffix(peerUserXmppId),
            isLast,
            `${conversationId}`
          )
          .then(res => {});
      }
    }
    dispatch(updateMessageStatusSuccess(mid, status));
    if (status === STATUS_DELETED) {
      dispatch(updateDeleteReferenceMessage(mid));
    }
  };
}

export function updateMessageStatusSuccess(mid: string, status: string) {
  return { type: types.CHAT_UPDATE_MESSAGE_STATUS, mid, status };
}

export function resetMessageReducerToInitData() {
  return { type: types.RESET_MESSAGE_TO_INIT_DATA };
}

export function updateMessageErrorSuccess(mid: string) {
  return { type: types.CHAT_UPDATE_MESSAGE_ERROR, mid, status: true };
}

export function removeMessageErrorSuccess(mid: string) {
  return { type: types.CHAT_REMOVE_MESSAGE_ERROR, mid };
}

export function removeStatusErrorMessage(mid: string) {
  return { type: types.REMOVE_STATUS_ERROR_MESSAGE, mid };
}

export function updateMessagesAfterConversationDeletedSuccess(peerXmppId: string) {
  return { type: types.CHAT_UPDATE_MESSAGES_STATUS, peerXmppId };
}

export function sendReadSuccess(message: any) {
  return { type: types.CHAT_SEND_MESSAGE_READ_SUCCESS, message };
}

export function updateMessageFail(message: any) {
  return {
    type: types.CHAT_UPDATE_MESSAGE_FAIL,
    message,
    status: STATUS_FAIL,
  };
}

export function updateGalleryStatusSuccess(message: any) {
  return { type: types.CHAT_UPDATE_ALBUM_STATUS_SUCCESS, message };
}

export function addSendMessage(message: any, type: string) {
  const loginId = getLoginXmppId();
  return {
    type: types.CHAT_ADD_SEND_MESSAGE_SUCCESS,
    message,
    bodyType: type,
    loginId,
  };
}

export function replaceMessage(message: any, type: string) {
  const loginId = getLoginXmppId();
  console.log('replaceMessage', message);
  return {
    type: types.CHAT_REPLACE_MESSAGE_SUCCESS,
    message,
    bodyType: type,
    loginId,
  };
}

export function addReceiveMessageSuccess(message: any, type: string) {
  const loginId = getLoginXmppId();
  return {
    type: types.CHAT_ADD_RECEIVE_MESSAGE_SUCCESS,
    message,
    bodyType: type,
    loginId,
  };
}

export function addReceiveMessage(message: any, type: string) {
  return (dispatch: any) => {
    if (message.type === chatTypes.TYPE_GROUP_CHAT || message.type === chatTypes.TYPE_HEART_MSG) {
      // console.log("messageData", message);
      const users = getUsers();
      let user = { userId: -1 };
      users.forEach(u => {
        if (u.userId.toString() === message.from.toString()) {
          user = u;
        }
      });
      if (user.userId !== -1) {
        dispatch(addReceiveMessageSuccess({ ...message, user }, type));
      } else {
        const xmppId = message.from;
        if (availableXmppId.indexOf(xmppId) === -1) {
          availableXmppId.push(xmppId);
          userService.getProfileSummary(xmppId).then(res => {
            if (res.success) {
              if (res.data.xmppId) {
                message.user = res.data;
                dispatch(userActions.getProfileGroupChatSuccess(res.data));
                dispatch(updateUserDetailInGroupChatMessage(res.data));
              }
            }
            dispatch(addReceiveMessageSuccess(message, type));
          });
        } else {
          dispatch(addReceiveMessageSuccess(message, type));
        }
      }
    } else {
      dispatch(addReceiveMessageSuccess(message, type));
      const conversations = myStore.getStore().getState().conversationsReducer;
      const statusEditor = conversations.selectedConversationInfo.editorStatus;
      const userId =
        conversations.selectedPeerVcard && conversations.selectedPeerVcard.userId ? conversations.selectedPeerVcard.userId : '';
      const xmppId =
        conversations.selectedPeerVcard && conversations.selectedPeerVcard.xmppId ? conversations.selectedPeerVcard.xmppId : '';

      const isMobile = !myStore.getStore().getState().commonStateReducer.isDesktop;
      if (statusEditor === CONVERSATION_STATUS.CAN_NOT_SEND && userId && xmppId) {
        setTimeout(() => {
          // set timeout to call conversation status to avoid issue "can not reply" from message authorize API
          dispatch(conversationInboxAction.getConversationStatus(userId, isMobile, xmppId));
        }, 800);
      }
    }
  };
}

export function updateLoading(data: any) {
  return { type: types.UPDATE_LOADING_CONVERSATION_DETAIL, data };
}

export function updateUserDetailInGroupChatMessage(data: any) {
  return { type: types.UPDATE_USER_GROUPCHAT_MESSAGE, user: data };
}

export function deletePeerAllMessage(peerXmppId: string) {
  return { type: types.CHAT_DELETE_PEER_ALL_MESSAGES, peerXmppId };
}

export function deleteAllGroupChatMessage(_fromJid: string) {
  return { type: types.GROUPCHAT_DELETE_ALL_MESSAGES, fromJid: _fromJid };
}

const MATCHING_DEFAULT_DATA = {
  senderMemberLevel: 1,
  recvMemberLevel: 1,
  isRecvMatching: false,
  isSenderMatching: false,
};

export function storeMessageReaction(message: any) {
  return { type: types.STORE_REACTION_MESSAGE_SUCCESS, message };
}

export function updateReactionSuccess(unicode: string, msgId: string, userIdReaction: number | null, isClearReaction: boolean) {
  const loginId = getLoginXmppId();
  const userId = userIdReaction || loginId;
  return {
    type: types.UPDATE_REACTION_MESSAGE_SUCCESS,
    unicode,
    mid: msgId,
    userId,
    isClearReaction,
  };
}

export function readAll(jid: string, messages: any[], isGroup: boolean) {
  return (dispatch: any) => {
    const _conversationId: number = myStore.getStore().getState().conversationsReducer.selectedConversationInfo.id || 0;
    const xmppMessage = myStore.getStore().getState().messageReducer;
    if (!isGroup) {
      if (messages && messages.length > 0) {
        messages.forEach((message, i) => {
          if (!message.read && !message.isDelete && !message.isHidden && !message.bySelf && _conversationId) {
            dispatch(sendRead(message, _conversationId, i === messages.length - 1));
          }
        });
      } else if (xmppMessage && xmppMessage.byId && jid) {
        const msgIds = xmppMessage.chat[jid];
        const conv = myStore
          .getStore()
          .getState()
          .conversationsReducer.data.find((c: IConversation) => c.id === _conversationId);
        const lastedMsgId = conv?.message?.id;
        if (msgIds) {
          for (let i = msgIds.length - 1; i >= 0; i--) {
            const message = xmppMessage.byId[msgIds[i]];
            if (
              message &&
              message.to !== jid &&
              message.status !== STATUS_READ &&
              message.status !== STATUS_DELETED &&
              message.status !== STATUS_HIDDEN &&
              _conversationId
            ) {
              dispatch(sendRead(message, _conversationId, msgIds[i] === lastedMsgId));
            }
          }
        }
      }
    }
  };
}

export function parseFromLocal(
  type: string,
  to: string,
  message: any = {},
  bodyType: keyof typeof msgTpl,
  isSending?: boolean,
  quotedMessage?: any,
  msgId?: string
) {
  const ext = message.ext || {};
  const obj: any = utils.copyMessage(message, msgTpl.base);
  if (quotedMessage && quotedMessage.body) {
    obj.refMsgId = quotedMessage.id;
    obj.refMsgShortDesc = quotedMessage.body.data;
    obj.refMsgType = quotedMessage.body.type;
    obj.refUserId = (quotedMessage.user && quotedMessage.user.userId) || -1;
    obj.refDisplayName = (quotedMessage.user && quotedMessage.user.displayName) || '';
    obj.refMsgExpTs = quotedMessage.expts || undefined;

    if (quotedMessage.body.type === TYPE_GALLERY) {
      obj.refMsgShortDesc = quotedMessage.body.data.galleryId;
      obj.refMsgTitle = quotedMessage.body.data.name;
    } else if (quotedMessage.body.type === TYPE_GIF) {
      obj.refMsgShortDesc = quotedMessage.body.data.fixedWidth;
    } else if (quotedMessage.body.type === TYPE_VIDEO_FILE) {
      obj.refMsgShortDesc = quotedMessage.body.data.thumbUrl;
    } else if (quotedMessage.body.type === TYPE_AUDIO_FILE) {
      obj.refMsgShortDesc = quotedMessage.body.data.duration;
    }
  }
  if (message.photoId) {
    obj.photoId = message.photoId;
  }
  if (message.photoData) {
    obj.photoData = message.photoData;
  }
  const body = utils.copyMessage(message, msgTpl[bodyType]);
  return {
    ...obj,
    notificationType: obj.notificationType || '',
    bySelf: obj.bySelf || '',
    isDeleteReaction: obj.isDeleteReaction || false,
    convId: obj.convId || undefined,
    reactOnMsgId: obj.msgId || undefined,
    expts: obj.expts || 0,
    isLocalMessage: obj.isLocalMessage || false,
    type,
    from: getLoginXmppId(),
    to: to.toString(),
    id: msgId || WebIM.conn.getUniqueId(),
    body: {
      ...body,
      ...ext,
      type: bodyType,
    },
    sent: !isSending,
    isParsedFromLocal: true,
    time: getTimeSystem(type),
    profilePhotoComment: getProfilePhotoComment(),
  };
}

export function sendRead(message: any, conversationId: number, _isLastMess: boolean) {
  return (dispatch: any) => {
    if (!WebIM.config.read) {
      return;
    }
    const _conversationId = conversationId || 0;
    const msgId = WebIM.conn.getUniqueId();
    const bodyId = message.id;
    const msg = new WebIM.message('read', msgId);
    if (msg.set) {
      msg.set({
        id: bodyId,
        to: message.from,
        conversationId: _conversationId,
      });
    }
    WebIM.conn.send(msg.body);
    const isLastMess = _isLastMess;
    const peerXmppId = getPeerXmppId();
    if (peerXmppId) {
      dispatch(updateMessageStatus(bodyId, STATUS_READ, peerXmppId, isLastMess, conversationId));
    }
  };
}

export function sendOpened(message: any) {
  return (dispatch: any) => {
    if (!message) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('delete', msgId);
    if (msg.set) {
      msg.set({
        id: message.id,
        to: message.from,
        isDeleteConversation: false,
        isDeclineMessage: false,
        isOpenedMessage: true,
      });
    }
    WebIM.conn.send(msg.body);
    const peerXmppId = getPeerXmppId();
    const conversationId = myStore.getStore().getState().conversationsReducer.selectedConversationInfo.id || '';
    dispatch(updateMessageStatus(message.id, STATUS_OPENED, peerXmppId, false, conversationId));
  };
}

export function sendAccepted(message: any) {
  return (dispatch: any) => {
    if (!message) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const bodyId = message.id;
    const msg = new WebIM.message('delete', msgId);
    if (msg.set) {
      msg.set({
        id: bodyId,
        to: message.from,
        isDeleteConversation: false,
        isDeclineMessage: false,
        isOpenedMessage: false,
        isAccepted: true,
      });
    }
    WebIM.conn.send(msg.body);
    const peerXmppId = getPeerXmppId();
    const conversationId = myStore.getStore().getState().conversationsReducer.selectedConversationInfo.id || '';
    dispatch(updateMessageStatus(message.id, STATE_STATUS_ACCEPT, peerXmppId, false, conversationId));
  };
}

export function sendDeclined(message: any) {
  return (dispatch: any) => {
    if (!WebIM.config.delete) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const bodyId = message.id;
    const msg = new WebIM.message('delete', msgId);
    if (msg.set) {
      msg.set({
        id: bodyId,
        to: message.from,
        isDeleteConversation: false,
        isDeclineMessage: true,
      });
    }
    WebIM.conn.send(msg.body);
    const peerXmppId = getPeerXmppId();
    const conversationId = myStore.getStore().getState().conversationsReducer.selectedConversationInfo.id || '';
    dispatch(updateMessageStatus(message.id, STATE_STATUS_DECLINE, peerXmppId, false, conversationId));
  };
}

export function sendDelete(id: string, from: string, _isDeleteConversation = false, _conversationId: number = 0, isGroup: boolean = false) {
  return () => {
    if (!WebIM.config.delete) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    if (!isGroup) {
      const bodyId = id;
      const msg = new WebIM.message('delete', msgId);
      if (msg.set) {
        msg.set({
          id: bodyId,
          to: from,
          isDeleteConversation: _isDeleteConversation,
          conversationId: _conversationId,
        });
      }
      WebIM.conn.send(msg.body);
    } else {
      const msg = new WebIM.message(TYPE_FASTEN_DELETE, msgId);
      if (msg.set) {
        msg.set({
          id,
          to: from,
        });
      }
      msg.setGroup(chatTypes.TYPE_GROUP_CHAT);
      WebIM.conn.send(msg.body);
    }
  };
}

export function sendMessageUpdate(message: any) {
  return (dispatch: any) => {
    if (!WebIM.config.update) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('update', msgId);
    if (msg.set) {
      msg.set({
        id: message.id,
        to: message.to,
        data: message.body,
      });
    }
    WebIM.conn.send(msg.body);
  };
}

export function sendChatState(to: string, chatStateType: ChatStateType) {
  return (dispatch: any) => {
    if (!WebIM.config.chatState) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('chatState', msgId);
    if (msg.set) {
      msg.set({
        to,
        data: chatStateType,
      });
    }
    WebIM.conn.send(msg.body);
  };
}

export function sendChatStateGone(to: string, chatStateType: ChatStateType) {
  return (dispatch: any) => {
    if (!WebIM.config.chatState) {
      return;
    }
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('chatState', msgId);
    if (msg.set) {
      msg.set({
        to,
        data: 'gone',
      });
    }
    WebIM.conn.send(msg.body);
  };
}

export function patchMessageReactions(
  chatType = chatTypes.TYPE_GROUP_CHAT,
  msgId: string,
  toXmppId: string,
  unicode = '',
  isDeleteReaction: boolean,
  { convId }: { convId?: number } = {}
) {
  return (dispatch: any, getState: any) => {
    try {
      const conversationInfo = getState().conversationsReducer.selectedConversationInfo;
      if (WebIMConfig.oneMessageOneReactionFromUser) {
        const originMessage = getState().messageReducer.byId[msgId];
        const loginUserId = getLoginUserId();
        if (originMessage && originMessage.reactions && loginUserId) {
          // Remove all reaction of login user in originMessage
          Object.keys(originMessage.reactions).forEach(uni => {
            if (originMessage.reactions[uni][loginUserId] && uni !== unicode) {
              const pMessage = parseFromLocal(chatType, toXmppId, { data: uni }, messageTypes.TYPE_REACTIONS, true);
              pMessage.bySelf = true;
              pMessage.isDeleteReaction = true;
              pMessage.convId = convId;
              pMessage.reactOnMsgId = msgId;

              pMessage.body.senderMemberLevel = conversationInfo.memberLevelUserLogin;
              pMessage.body.recvMemberLevel = conversationInfo.recvMemberLevel;
              pMessage.body.isRecvMatching = conversationInfo.isRecvMatching;
              pMessage.body.isSenderMatching = conversationInfo.isSenderMatching;

              const { body, id, to } = pMessage;
              const { type, data } = body;
              const msgObj = new WebIM.message(type, id);
              if (msgObj.set) {
                msgObj.set({
                  time: pMessage.time,
                  data,
                  to,
                  reactOnMsgId: msgId,
                  isDeleteReaction: true,
                  group: chatType === chatTypes.TYPE_GROUP_CHAT,
                });
              }

              WebIM.conn.send(msgObj.body);

              if (chatType === chatTypes.TYPE_CHAT) {
                if (!WebIMConfig.isEnableStreamManagementFeature) {
                  dispatch(
                    notifyMessageSent(to, data, TYPE_REACTION_MESSAGE, '', {
                      messageObject: pMessage,
                    })
                  );
                }
              } else {
                if (!WebIMConfig.isEnableStreamManagementFeature) {
                  dispatch(
                    notifyMessageSentGroupChat(data, to, {
                      messageObject: pMessage,
                    })
                  );
                }
              }
              dispatch(updateReactionSuccess(uni, msgId, null, true));
              dispatch(storeMessageReaction(pMessage));
            }
          });
        }
      }

      const _message = { data: unicode };
      const pMessage = parseFromLocal(chatType, toXmppId, _message, messageTypes.TYPE_REACTIONS, true);
      pMessage.bySelf = true;
      pMessage.isDeleteReaction = isDeleteReaction;
      pMessage.convId = convId;
      pMessage.reactOnMsgId = msgId;

      pMessage.body.senderMemberLevel = conversationInfo.memberLevelUserLogin;
      pMessage.body.recvMemberLevel = conversationInfo.recvMemberLevel;
      pMessage.body.isRecvMatching = conversationInfo.isRecvMatching;
      pMessage.body.isSenderMatching = conversationInfo.isSenderMatching;

      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);

      if (msgObj.set) {
        msgObj.set({
          // TODO: cate type == 'chatrooms'
          time: pMessage.time,
          data,
          to,
          reactOnMsgId: msgId,
          isDeleteReaction,
          group: chatType === chatTypes.TYPE_GROUP_CHAT,
        });
      }
      WebIM.conn.send(msgObj.body);
      if (chatType === chatTypes.TYPE_CHAT) {
        if (!WebIMConfig.isEnableStreamManagementFeature) {
          dispatch(
            notifyMessageSent(to, data, TYPE_REACTION_MESSAGE, '', {
              messageObject: pMessage,
            })
          );
        }
      } else {
        if (!WebIMConfig.isEnableStreamManagementFeature) {
          dispatch(
            notifyMessageSentGroupChat(data, to, {
              messageObject: pMessage,
            })
          );
        }
      }
      dispatch(updateReactionSuccess(unicode, msgId, null, isDeleteReaction));
      dispatch(storeMessageReaction(pMessage));

      return Promise.resolve(pMessage);
    } catch (e) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}

export function sendTxtMessage({
  chatType,
  chatId,
  message = '',
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  msgId,
  options: { notificationType, convId } = { notificationType: TYPE_MESSAGE, convId: null },
}: SendMessageParams) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch: any, getState: any) => {
    try {
      const selectedGroup = getState().groupChatReducer.selectedGroup;
      const isMessagePublicGroupChat =
        selectedGroup?.roomJid === chatId || !!getPublicGroupChatRooms()?.find((g: any) => g.roomJid === chatId);
      const _message = { data: message };
      const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_TEXT, true, undefined, msgId);
      // const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_REACTIONS, true);
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.notificationType = notificationType;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          // TODO: cate type == 'chatrooms'
          time: pMessage.time,
          profilePhotoComment: pMessage.profilePhotoComment,
          data,
          to,
          roomType: false,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          notificationType,
          storeMessageByTigase: isMessagePublicGroupChat,
          success() {
            // console.log('-----_message success-----');
          },
          fail() {
            // console.log('-----_message fail-----');
          },
        });
      }

      // TODO: update group chat logic
      if (chatType === chatTypes.TYPE_GROUP_CHAT) {
        msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
      }
      // console.log("to", to);
      // msgObj.body.data = [dataEmoji[0].unicode, dataEmoji[1].unicode];
      // WebIM.conn.send(msgObj.body);

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, chatType));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }
      // console.log('pMessage', pMessage)
      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}

export function sendGifMessage({
  chatType,
  chatId,
  message = '',
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  msgId,
  options: { convId } = { convId: null },
}: SendMessageParams) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;

  return (dispatch: any) => {
    try {
      const _message = { data: message };
      const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_GIF, true, undefined, msgId);
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          // TODO: cate type == 'chatrooms'
          time: pMessage.time,
          data,
          to,
          roomType: false,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          success() {
            // console.log('-----_message success-----');
          },
          fail() {
            // console.log('-----_message fail-----');
          },
        });
      }

      if (chatType === chatTypes.TYPE_GROUP_CHAT) {
        msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
      }

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      // update unreadCount and last _message for conversation
      dispatch(addSendMessage(pMessage, chatType));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }
      return Promise.resolve(pMessage);
    } catch (e) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(null);
    }
  };
}

export function sendGalleryMessage({
  chatType,
  chatId,
  galleryData = '',
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  msgId,
  options: { convId, expts } = { convId: null, expts: THREE_MONTHS },
}: SendMessageParams) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch: any) => {
    try {
      const exptsTimeDefault = myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value;
      const exptsTime = new Date().getTime() + (expts || exptsTimeDefault || THREE_MONTHS);
      // const exptsTime = exptsTimeDefault !== 0 ? new Date().getTime() + exptsTimeDefault : 0;
      const _message = { data: galleryData, expts: exptsTime };
      const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_GALLERY, true, undefined, msgId);
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      // console.log('sendGalleryMessage',pMessage);
      if (msgObj.set) {
        msgObj.set({
          // TODO: cate type == 'chatrooms'
          time: pMessage.time,
          data,
          to,
          roomType: false,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          expts: exptsTime,
          success() {
            // console.log('-----_message success-----');
          },
          fail() {
            // console.log('-----_message fail-----');
          },
        });
      }

      // TODO: update group chat logic
      // if (type !== 'chat') {
      //   msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
      // }
      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));

      // update unreadCount and last _message for conversation
      dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      return Promise.resolve(pMessage);
    } catch (e) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(null);
    }
  };
}

export function sendWhisperMessage(roomJid: string, chatType: string, chatId: string, message = '', isModerator = false) {
  return (dispatch: Dispatch) => {
    const _message = { data: message };
    const pMessage = parseFromLocal(chatType, `${roomJid}/${chatId}`, _message, messageTypes.TYPE_TEXT, true);
    const { body, id, to } = pMessage;
    const { type, data } = body;
    const msgObj = new WebIM.message(type, id);
    if (msgObj.set) {
      msgObj.set({
        // TODO: cate type == 'chatrooms'
        time: pMessage.time,
        data,
        to,
        roomType: false,
        isPrivate: true,
        isModerator,
        success() {
          // console.log('-----_message success-----');
        },
        fail() {
          // console.log('-----_message fail-----');
        },
      });
    }
    const loginId = getLoginXmppId();
    pMessage.body = {
      ...pMessage.body,
      isPrivate: 'private-msg',
      isModerator,
    };
    pMessage.from = loginId;
    WebIM.conn.send(msgObj.body);
    // pMessage.convId = getCurrentSelectedConversationId();
    messageBufferAction.saveMessageToBufferStorage(pMessage);
    dispatch(addSendMessage(pMessage, chatType));
  };
}

export function sendHeartMessage(chatType: string, chatId: string, message = '') {
  return (dispatch: any) => {
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message(chatType, msgId);
    if (msg.set) {
      msg.set({
        to: chatId,
        data: message,
        roomType: false,
      });
    }
    WebIM.conn.send(msg.body);
  };
}

export function sendRecentlyPhotoMessage({
  chatId,
  source = {},
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  chatType = CHAT_TYPES.CHAT,
  options: { convId, expts } = { convId: null, expts: 0 },
}: SendMessageParams) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch: any) => {
    try {
      let pMessage = null;
      const id = WebIM.conn.getUniqueId();

      const isVideoMp4File = source.mediaType === MEDIA_TYPE.VIDEO;
      const type = isVideoMp4File ? messageTypes.TYPE_VIDEO_FILE : messageTypes.TYPE_IMAGE;
      // const type = messageTypes.TYPE_IMAGE;
      const to = chatId.toString();
      const msgObj = new WebIM.message(type, id);
      const exptsTimeDefault = myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS;
      const exptsTime = new Date().getTime() + (expts || exptsTimeDefault);
      const data = isVideoMp4File ? { ...source.data, ownerUserId: getLoginUserId() } : source.data.fullUrl;
      // getLoginUserId
      msgObj.set({
        time: getTimeSystem(chatType),
        body: {
          data,
          type,
          expts: exptsTime,
          noUpload: true,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
        },
        expts: exptsTime,
        to,
        createdAt: new Date(),
      });

      if (chatType === chatTypes.TYPE_GROUP_CHAT) {
        msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
      }

      WebIM.conn.send(msgObj.body);
      if (!isVideoMp4File) {
        msgObj.body.photoId = source.data.photoId;
      }
      pMessage = parseFromLocal(chatType, chatId, msgObj.body, type, true);
      pMessage.body.data = data;
      if (!isVideoMp4File) {
        pMessage.photoData = source.data;
      }
      pMessage.id = id;
      pMessage.bySelf = true;
      pMessage.expts = exptsTime;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.convId = convId;
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }
      return Promise.resolve(pMessage);
    } catch (e) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(null);
    }
  };
}

interface SendImgMessageOptions {
  convId?: number | null;
  conversationKey?: string;
  expts?: number;
}

interface SendImgMessageParams {
  chatType: string;
  chatId: string;
  source?: {
    id?: number;
    fileName?: string;
    filename?: string;
    name?: string;
    fileSize?: number;
    filesize?: number;
    size?: number;
    body?: object;
    width?: number;
    height?: number;
    browserUpload?: string;
    duration?: number;
    uri?: string;
    fileData?: string;
    timeStamp?: number;
  };
  senderMemberLevel?: number;
  recvMemberLevel?: number;
  isRecvMatching?: boolean;
  isSenderMatching?: boolean;
  isReSend?: boolean;
  action?: (uri: string | undefined) => {};
  msgId?: string;
  options?: SendImgMessageOptions;
}

interface SendMediaMessageParams extends SendImgMessageParams {}

export function sendImgMessage({
  chatType,
  chatId,
  source = {},
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  isReSend = false,
  action,
  msgId,
  options: { convId, conversationKey, expts } = { convId: null, conversationKey: '', expts: 0 },
}: SendImgMessageParams) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      try {
        let isAllowDispatchUpdateUpLoading = !isReSend;
        const id = msgId || WebIM.conn.getUniqueId();
        const isVideoMp4File = isVideoFile(source);
        const type = isVideoMp4File ? messageTypes.TYPE_VIDEO_FILE : messageTypes.TYPE_IMAGE;
        const to = chatId.toString();
        const msgObj = new WebIM.message(type, id);
        const fileName = source?.fileName || source?.filename || source?.name || '';
        const fileSize = source?.fileSize || source?.filesize || source?.size || 0;
        const accessToken = WebIM.config.rhpToken;
        const exptsTime = expts || myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS;
        const userVideoUploadMaxRetries = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadMaxRetries;
        const userVideoUploadPollInterval = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadPollInterval;
        if (isReSend) {
          if (msgObj.set) {
            msgObj.set({
              time: getTimeSystem(chatType),
              id: source.id || id,
              body: {
                expts: exptsTime !== 0 ? new Date().getTime() + exptsTime : 0,
                ...source.body,
                noUpload: true,
                senderMemberLevel,
                recvMemberLevel,
                isRecvMatching: numberRecvMatching,
                isSenderMatching: numberSenderMatching,
                profilePhotoComment: getProfilePhotoComment(),
              },
              expts: exptsTime !== 0 ? new Date().getTime() + exptsTime : 0,
              senderMemberLevel,
              recvMemberLevel,
              isRecvMatching: numberRecvMatching,
              isSenderMatching: numberSenderMatching,
              to,
            });
          }

          if (myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
            dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
          }
        } else {
          if (msgObj.set) {
            msgObj.set({
              time: getTimeSystem(chatType),
              expts: exptsTime !== 0 ? new Date().getTime() + exptsTime : 0,
              apiUrl: WebIM.config.fileURL,
              compress: isVideoMp4File && !isNative,
              endPoint: isVideoMp4File ? urls.POST_CREATE_USER_VIDEO : '',
              senderMemberLevel,
              recvMemberLevel,
              isRecvMatching: numberRecvMatching,
              isSenderMatching: numberSenderMatching,
              profilePhotoComment: getProfilePhotoComment(),
              ext: {
                file_length: fileSize,
                filename: fileName,
                filetype: fileName && fileName.split('.').pop(),
                width: source.width,
                height: source.height,
                browserUpload: source.browserUpload,
                duration: source.duration || 0,
                userVideoUploadMaxRetries,
                userVideoUploadPollInterval,
              },
              file: source.browserUpload
                ? source
                : {
                    data: {
                      uri: source.uri,
                      type: isVideoMp4File ? 'video/mp4' : 'application/octet-stream',
                      name: fileName,
                      size: fileSize,
                      fileData: source.fileData,
                      timeStamp: source.timeStamp,
                    },
                  },
              to,
              isGroup: chatType === TYPE_GROUP_CHAT,
              roomType: '',
              onFileUploadError(error: any) {
                console.log('onFileUploadError', error);
                const isAborted = error.data?.message?.includes('Aborted');
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 0,
                    isVideoMp4File,
                    to: chatId,
                  })
                );
                dispatch(removeMessageErrorSuccess(id as string));
                isAllowDispatchUpdateUpLoading = false;
                if (isVideoMp4File) {
                  if (isAborted) {
                    WebIMConfig.onAbortUploadVideoMessenger?.();
                  } else {
                    WebIMConfig.onUploadVideoMessengerError?.();
                  }
                }
                resolve({ error: true, source, id });
              },
              onFileUploadComplete(data: any) {
                const msg = {
                  data: data && data[0] ? data[0].FullUrl : '',
                  photoId: -1,
                  photoData: {},
                };
                if (data?.[0]) {
                  if (isVideoMp4File) {
                    const videoData = mappingVideoFile(data[0].Video);
                    msg.data = { ...videoData, ownerUserId: getLoginUserId() };
                  } else {
                    // As needed photoId to send notify API, and avoid break old structure message, we add field photoId here
                    msg.photoId = data[0]?.PhotoID;
                    msg.photoData = RecentlySentPhotoModel.mappingPhoto(data[0]);
                  }
                  // dispatch media data to shared data reducer

                  const media = data.map((d: any) => ({
                    MediaType: isVideoMp4File ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.PHOTO,
                    Data: isVideoMp4File ? d?.Video : d,
                  }));
                  dispatch(addUserMediaSuccess(RecentlySentPhotoModel.mappingListMedia(media)));
                }
                const newMessage = parseFromLocal(chatType, chatId, msg, type, true);
                newMessage.id = id;
                newMessage.expts = exptsTime !== 0 ? new Date().getTime() + exptsTime : 0;
                newMessage.convId = convId;
                newMessage.body.recvMemberLevel = recvMemberLevel;
                newMessage.body.senderMemberLevel = senderMemberLevel;
                newMessage.body.isRecvMatching = numberRecvMatching;
                newMessage.body.isSenderMatching = numberSenderMatching;
                if (typeof action === 'function') {
                  action(source?.uri);
                }
                if (data && data.length > 0) {
                  dispatch(
                    updateLoading({
                      isLoading: false,
                      msgId: id,
                      percent: 100,
                      isVideoMp4File,
                      to: chatId,
                    })
                  );
                  messageBufferAction.saveMessageToBufferStorage(newMessage);
                  dispatch(replaceMessage(newMessage, type));
                  if (myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
                    dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
                  }
                  resolve({ ...newMessage, conversationKey });
                } else {
                  dispatch(
                    updateLoading({
                      isLoading: false,
                      msgId: id,
                      percent: 0,
                      isVideoMp4File,
                      to: chatId,
                    })
                  );
                  dispatch(
                    commonStateActions.updateInAppNotificationData({
                      isFailedNotification: true,
                      errorCodeUploadImage: data.ResponseStatus ? data.ResponseStatus.ErrorCode : '',
                    })
                  );
                }
              },
              success(id: string) {
                // console.log("success",id);
              },
              onFileUploadProgress(process: { loaded: number; total: number }) {
                let percent = Math.ceil((process.loaded / process.total) * 100);
                console.log('-----upload video process-----', percent + '%');
                dispatch(
                  updateLoading({
                    isLoading: true,
                    msgId: id,
                    percent: percent,
                    isVideoMp4File,
                    to: chatId,
                  })
                );
              },
              accessToken,
            });
          }
        }

        if (chatType === chatTypes.TYPE_GROUP_CHAT) {
          msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
        }
        WebIM.conn.send(msgObj.body);
        const pMessage = parseFromLocal(chatType, chatId, msgObj.body, type, true);
        pMessage.bySelf = true;
        // uri only stored in client
        if (isReSend) {
          // @ts-ignore
          pMessage.body.data = msgObj.body && msgObj.body.body ? msgObj.body.body.data : '';
        } else {
          pMessage.body.data = source.uri;
        }
        pMessage.id = id;
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        if (isReSend) {
          pMessage.convId = convId;
          messageBufferAction.saveMessageToBufferStorage(pMessage);
          dispatch(addSendMessage(pMessage, type));
        } else {
          pMessage.isLocalMessage = true;
          pMessage.convId = convId;
          //          messageBufferAction.saveMessageToBufferStorage(pMessage);
          dispatch(addSendMessage(pMessage, type));
        }
        // console.log('pMessage', pMessage, chatType, chatId, msgObj.body);
        // if add message from local, width & height of this message will be wrong, we must add message after upload message completed
        // dispatch(addSendMessage(pMessage, type));
        if (isAllowDispatchUpdateUpLoading) {
          dispatch(
            updateLoading({
              isLoading: true,
              msgId: id,
              percent: 0,
              isVideoMp4File,
              to: chatId,
            })
          );
        }
        // update unreadCount and last message for conversation
        if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
          dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
        }

        if (isReSend) {
          resolve({ ...pMessage, conversationKey }); // use promise for resend message
        }
      } catch (e) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(null);
      }
    });
  };
}

export function sendMediaMessage({
  chatType,
  chatId,
  source = {},
  senderMemberLevel = 1,
  recvMemberLevel = 1,
  isRecvMatching = false,
  isSenderMatching = false,
  isReSend = false,
  action,
  msgId,
  options: { convId, conversationKey, expts } = { convId: null, conversationKey: '', expts: 0 },
}: SendMediaMessageParams) {
  console.log('source', source);
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      try {
        let isAllowDispatchUpdateUpLoading = !isReSend;
        const id = msgId || WebIM.conn.getUniqueId();
        const isVideoMp4File = isVideoFile(source);
        const isAudio = isAudioFile(source);
        const type = isVideoMp4File ? messageTypes.TYPE_VIDEO_FILE : isAudio ? messageTypes.TYPE_AUDIO_FILE : messageTypes.TYPE_IMAGE;
        const to = chatId.toString();
        const msgObj = new WebIM.message(type, id);
        const fileName = source?.fileName || source?.filename || source?.name || '';
        const fileSize = source?.fileSize || source?.filesize || source?.size || 0;
        const accessToken = WebIM.config.rhpToken;
        const exptsTime = expts || myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS;
        const exptsValue = exptsTime !== 0 ? new Date().getTime() + exptsTime : 0;
        const userVideoUploadMaxRetries = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadMaxRetries;
        const userVideoUploadPollInterval = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadPollInterval;
        if (isReSend) {
          if (msgObj.set) {
            msgObj.set({
              time: getTimeSystem(chatType),
              id: source.id || id,
              body: {
                expts: exptsValue,
                ...source.body,
                noUpload: true,
                senderMemberLevel,
                recvMemberLevel,
                isRecvMatching: numberRecvMatching,
                isSenderMatching: numberSenderMatching,
                profilePhotoComment: getProfilePhotoComment(),
              },
              expts: exptsValue,
              senderMemberLevel,
              recvMemberLevel,
              isRecvMatching: numberRecvMatching,
              isSenderMatching: numberSenderMatching,
              to,
            });
          }

          if (!isAudio && myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
            dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
          }
        } else {
          if (msgObj.set) {
            msgObj.set({
              time: getTimeSystem(chatType),
              expts: exptsValue,
              apiUrl: WebIM.config.fileURL,
              compress: isVideoMp4File && !isNative,
              endPoint: isAudio ? urls.POST_CREATE_USER_AUDIO : isVideoMp4File ? urls.POST_CREATE_USER_VIDEO : '',
              senderMemberLevel,
              recvMemberLevel,
              isRecvMatching: numberRecvMatching,
              isSenderMatching: numberSenderMatching,
              profilePhotoComment: getProfilePhotoComment(),
              duration: source.duration || 0,
              ext: {
                file_length: fileSize,
                filename: fileName,
                filetype: fileName && fileName.split('.').pop(),
                width: source.width,
                height: source.height,
                browserUpload: source.browserUpload,
                duration: source.duration || 0,
                userVideoUploadMaxRetries,
                userVideoUploadPollInterval,
              },
              file: source.browserUpload
                ? source
                : {
                    data: {
                      uri: source.uri,
                      type: isVideoMp4File ? 'video/mp4' : isAudio ? 'audio/aac' : 'application/octet-stream',
                      name: fileName,
                      size: fileSize,
                      fileData: source.fileData,
                      timeStamp: source.timeStamp,
                    },
                  },
              to,
              isGroup: chatType === TYPE_GROUP_CHAT,
              roomType: '',
              onFileUploadError(error: any) {
                console.log('onFileUploadError', error);
                const isAborted = error.data?.message?.includes('Aborted');
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 0,
                    isVideoMp4File,
                    to: chatId,
                    isAudio,
                  })
                );
                isAllowDispatchUpdateUpLoading = false;
                if (isVideoMp4File) {
                  dispatch(removeMessageErrorSuccess(id as string));
                  if (isAborted) {
                    WebIMConfig.onAbortUploadVideoMessenger?.();
                  } else {
                    WebIMConfig.onUploadVideoMessengerError?.();
                  }
                } else {
                  setTimeout(() => {
                    dispatch(updateMessageErrorSuccess(id));
                  }, 100);
                }
                resolve({ error: true, source, id });
              },
              onFileUploadComplete(data: any) {
                const msg = {
                  body: {
                    data: data && data[0] ? data[0].FullUrl : '',
                  },
                  data: data && data[0] ? data[0].FullUrl : '',
                  photoId: -1,
                  photoData: {},
                };
                if (data?.[0]) {
                  if (isVideoMp4File) {
                    const videoData = mappingVideoFile(data[0].Video);
                    msg.data = { ...videoData, ownerUserId: getLoginUserId() };
                  } else {
                    // As needed photoId to send notify API, and avoid break old structure message, we add field photoId here
                    msg.photoId = data[0]?.PhotoID;
                    msg.photoData = RecentlySentPhotoModel.mappingPhoto(data[0]);
                  }
                  // dispatch media data to shared data reducer
                  if (isAudio) {
                    // do nothing here, we don't need to dispatch audio data to shared data reducer
                  } else {
                    const media = data.map((d: any) => ({
                      MediaType: isVideoMp4File ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.PHOTO,
                      Data: isVideoMp4File ? d?.Video : d,
                    }));
                    dispatch(addUserMediaSuccess(RecentlySentPhotoModel.mappingListMedia(media)));
                  }
                } else if (data.fileName && isAudio) {
                  msg.data = { ...data, ownerUserId: getLoginUserId() };
                }
                const newMessage = parseFromLocal(chatType, chatId, msg, type, true);
                newMessage.id = id;
                newMessage.expts = exptsValue;
                newMessage.convId = convId;
                newMessage.body.recvMemberLevel = recvMemberLevel;
                newMessage.body.senderMemberLevel = senderMemberLevel;
                newMessage.body.isRecvMatching = numberRecvMatching;
                newMessage.body.isSenderMatching = numberSenderMatching;
                if (typeof action === 'function') {
                  action(source?.uri);
                }
                if (data && (data.length > 0 || data.fileName)) {
                  dispatch(
                    updateLoading({
                      isLoading: false,
                      msgId: id,
                      percent: 100,
                      isVideoMp4File,
                      isAudio,
                      to: chatId,
                    })
                  );
                  messageBufferAction.saveMessageToBufferStorage(newMessage);
                  dispatch(replaceMessage(newMessage, type));
                  if (!isAudio && myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
                    dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
                  }
                  console.log('newMessage', newMessage);
                  resolve({ ...newMessage, conversationKey });
                } else {
                  dispatch(
                    updateLoading({
                      isLoading: false,
                      msgId: id,
                      percent: 0,
                      isVideoMp4File,
                      isAudio,
                      to: chatId,
                    })
                  );
                  dispatch(
                    commonStateActions.updateInAppNotificationData({
                      isFailedNotification: true,
                      errorCodeUploadImage: data.ResponseStatus ? data.ResponseStatus.ErrorCode : '',
                    })
                  );
                }
              },
              success(id: string) {
                // console.log("success",id);
              },
              onFileUploadProgress(process: { loaded: number; total: number }) {
                let percent = Math.ceil((process.loaded / process.total) * 100);
                console.log('-----upload video process-----', percent + '%');
                dispatch(
                  updateLoading({
                    isLoading: true,
                    msgId: id,
                    percent: percent,
                    isVideoMp4File,
                    to: chatId,
                    isAudio,
                  })
                );
              },
              accessToken,
            });
          }
        }

        if (chatType === chatTypes.TYPE_GROUP_CHAT) {
          msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
        }
        WebIM.conn.send(msgObj.body);
        const pMessage = parseFromLocal(chatType, chatId, msgObj.body, type, true);
        pMessage.bySelf = true;
        // uri only stored in client
        if (isReSend) {
          // @ts-ignore
          pMessage.body.data = msgObj.body && msgObj.body.body ? msgObj.body.body.data : '';
        } else if (isAudio) {
          pMessage.body.data = source;
        } else {
          pMessage.body.data = source.uri;
        }
        console.log('pMessage', pMessage);
        pMessage.id = id;
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        if (isReSend) {
          pMessage.convId = convId;
          messageBufferAction.saveMessageToBufferStorage(pMessage);
          dispatch(addSendMessage(pMessage, type));
        } else {
          pMessage.isLocalMessage = true;
          pMessage.convId = convId;
          //          messageBufferAction.saveMessageToBufferStorage(pMessage);
          dispatch(addSendMessage(pMessage, type));
        }
        // console.log('pMessage', pMessage, chatType, chatId, msgObj.body);
        // if add message from local, width & height of this message will be wrong, we must add message after upload message completed
        // dispatch(addSendMessage(pMessage, type));
        if (isAllowDispatchUpdateUpLoading) {
          dispatch(
            updateLoading({
              isLoading: true,
              msgId: id,
              percent: 0,
              isVideoMp4File,
              to: chatId,
              isAudio,
            })
          );
        }
        // update unreadCount and last message for conversation
        if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
          dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
        }

        if (isReSend) {
          resolve({ ...pMessage, conversationKey }); // use promise for resend message
        }
      } catch (e) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(null);
      }
    });
  };
}

interface SendGiftOptions {
  convId?: number | null;
}

interface SendGiftParams {
  chatType?: string;
  chatId: string;
  gift: any;
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  msgId?: string;
  options?: SendGiftOptions;
}

export function sendGift({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  gift,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  options: { convId } = { convId: null },
}: SendGiftParams) {
  return (dispatch: any) => {
    const sendGiftWS = (res: any) => {
      try {
        const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const dataGift = { ...gift, ...(res?.data || {}) };
        const _message = {
          data: {
            data: dataGift.data,
            description: dataGift.description,
            diamonds: dataGift.diamonds,
            giftId: dataGift.giftId,
            imageURL: dataGift.imageURL,
            level: dataGift.level,
            name: dataGift.name,
            price: dataGift.price,
          },
        };
        const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_GIFT, true, undefined, msgId);
        pMessage.bySelf = true;
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        pMessage.notificationType = TYPE_GIFT;
        const { body, id, to } = pMessage;
        const { type, data } = body;
        const msgObj = new WebIM.message(type, id);
        if (msgObj.set) {
          msgObj.set({
            time: pMessage.time,
            data,
            to,
            success() {
              // console.log('-----_message success-----');
            },
            fail() {
              // console.log('-----_message fail-----');
            },
            senderMemberLevel,
            recvMemberLevel,
            isRecvMatching: numberRecvMatching,
            isSenderMatching: numberSenderMatching,
          });
        }

        // if (chatType === chatTypes.TYPE_GROUP_CHAT) {
        //   msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
        // }
        WebIM.conn.send(msgObj.body);
        pMessage.convId = convId;
        // Add message to buffer storage
        messageBufferAction.saveMessageToBufferStorage(pMessage);
        dispatch(addSendMessage(pMessage, type));
        if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
          dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
        }
        // console.log('pMessage', pMessage)
        // return giftServices.giveGift(chatId, gift?.consumablePriceID).then(res => {
        //   console.log('res', res);
        //   return res;
        // });
        return Promise.resolve(pMessage);
      } catch (e) {
        console.log(e);
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(e);
      }
    };
    if (msgId) {
      return sendGiftWS({});
    }
    if (!gift?.consumableID) {
      return Promise.reject(new Error('Gift data invalid!!!'));
    }
    return giftServices.giveGift(chatId, gift.consumableID).then((res: any) => {
      if ((res?.success && res?.data) || (WebIMConfig?.forceSendGiftDevelopment && process?.env?.NODE_ENV === 'development')) {
        return sendGiftWS(res);
      }
      return Promise.reject(new Error('Can not get gift data!!!'));
    });
  };
}

interface SendShareDateFinderMessageOptions {
  convId?: number | null;
}

interface SendShareDateFinderMessageParams {
  chatType: string;
  chatId: string;
  date: any;
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  msgId?: string;
  options?: SendShareDateFinderMessageOptions;
}

export function sendShareDateFinderMessage({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  date,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  options: { convId } = { convId: null },
}: SendShareDateFinderMessageParams) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: {
            id: date.id,
          },
        },
        messageTypes.TYPE_SHARE_DATE,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;

      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
        });
      }

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        // Implementation here
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  };
}

interface SendShareEventMessageParams {
  chatType: string;
  chatId: string;
  event: { id: number; isShareTicket?: boolean };
  expts?: number;
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  msgId?: string;
  options?: { convId?: number | null; notificationType: NotificationType };
}

export function sendShareEventMessage({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  event,
  expts,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  options: { convId, notificationType } = { convId: null, notificationType: TYPE_INVITE },
}: SendShareEventMessageParams) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = 1;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: {
            id: event.id,
          },
        },
        event.isShareTicket ? messageTypes.TYPE_SHARE_EVENT_TICKET : messageTypes.TYPE_SHARE_EVENT,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.body.notificationType = notificationType;

      const exptsTimeDefault = myStore.getStore().getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS;
      const exptsTime = new Date().getTime() + (expts || exptsTimeDefault);
      pMessage.expts = exptsTime;

      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
        });
      }

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  };
}

interface SendShareLocationMessageParams {
  chatType: string;
  chatId: string;
  location: { longitude: number; latitude: number };
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  msgId?: string;
  options?: { convId?: number | null };
}

export function sendShareLocationMessage({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  location,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  options: { convId } = { convId: null },
}: SendShareLocationMessageParams) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: {
            longitude: location.longitude,
            latitude: location.latitude,
          },
        },
        messageTypes.TYPE_SHARE_LOCATION,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;

      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
        });
      }

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  };
}

export function sendScreenshotMessage(
  chatType: ChatType = CHAT_TYPES.CHAT,
  chatId: string,
  screenshot = '',
  { senderMemberLevel, recvMemberLevel, isRecvMatching, isSenderMatching } = MATCHING_DEFAULT_DATA,
  msgId?: string,
  { convId, notificationType }: { convId?: number; notificationType?: string } = {}
) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: screenshot || '',
        },
        messageTypes.TYPE_TOOK_SCREEN_SHOT,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.notificationType = notificationType;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
        });
      }

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      // messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== 'groupchat') {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  };
}

export function quoteMessageBySendImage(
  chatType: ChatType = CHAT_TYPES.GROUP_CHAT,
  toXmppId: string,
  source: any,
  messageQuoted: any,
  { senderMemberLevel, recvMemberLevel, isRecvMatching, isSenderMatching } = MATCHING_DEFAULT_DATA,
  { convId, expts }: { convId?: number; expts?: number } = {}
) {
  return (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      try {
        const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const msgQuoted = getState().messageReducer.byId[messageQuoted.id];
        if (!msgQuoted) {
          return reject(new Error('Message quoted not found'));
        }
        const id = WebIM.conn.getUniqueId();
        const msgObj = new WebIM.message(messageTypes.TYPE_QUOTE_MESSAGE, id);
        const fileName = source?.fileName || source?.filename || source?.name || '';
        const fileSize = source?.fileSize || source?.filesize || source?.size || 0;
        const accessToken = WebIM.config.rhpToken;
        const messageQuotedData = {
          type: messageQuoted.body ? messageQuoted.body.type : messageTypes.TYPE_TEXT,
          data: getDataMsgQuoted(messageQuoted),
          exptsTime: 0,
        };

        if (messageQuoted.body && messageQuoted.body.type === messageTypes.TYPE_IMAGE) {
          messageQuotedData.exptsTime = messageQuoted.expts || undefined;
        }
        const isVideoMp4File = isVideoFile(source);
        const type = isVideoMp4File ? messageTypes.TYPE_VIDEO_FILE : messageTypes.TYPE_IMAGE;
        // Implementation here
        const userVideoUploadMaxRetries = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadMaxRetries;
        const userVideoUploadPollInterval = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadPollInterval;
        if (msgObj.set) {
          msgObj.set({
            time: getTimeSystem(chatType),
            type,
            apiUrl: WebIM.config.fileURL,
            senderMemberLevel,
            recvMemberLevel,
            isRecvMatching: numberRecvMatching,
            isSenderMatching: numberSenderMatching,
            compress: isVideoMp4File && !isNative,
            endPoint: isVideoMp4File ? urls.POST_CREATE_USER_VIDEO : '',
            reactOnMsgId: messageQuoted.id,
            reactOnMsgUserId: msgQuoted.user ? msgQuoted.user.userId : 0,
            reactOnMsgUsername: msgQuoted.user ? msgQuoted.user.displayName : '',
            messageQuoted: messageQuotedData,
            expts: new Date().getTime() + (expts || getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS),
            ext: {
              file_length: fileSize,
              filename: fileName,
              filetype: fileName && fileName.split('.').pop(),
              width: source.width,
              height: source.height,
              browserUpload: source.browserUpload,
              userVideoUploadMaxRetries,
              userVideoUploadPollInterval,
            },
            file: source.browserUpload
              ? source
              : {
                  data: {
                    uri: source.uri,
                    type: isVideoMp4File ? 'video/mp4' : 'application/octet-stream',
                    name: fileName,
                    size: fileSize,
                  },
                },
            to: toXmppId,
            isGroup: chatType === TYPE_GROUP_CHAT,
            roomType: '',
            onFileUploadError(error: any) {
              console.log('onFileUploadError', error);
              const isAborted = error.data?.message?.includes('Aborted');
              dispatch(
                updateLoading({
                  isLoading: false,
                  msgId: id,
                  percent: 0,
                  isVideoMp4File,
                  to: toXmppId,
                })
              );
              dispatch(removeMessageErrorSuccess(id as string));
              if (isVideoMp4File) {
                if (isAborted) {
                  WebIMConfig.onAbortUploadVideoMessenger?.();
                } else {
                  WebIMConfig.onUploadVideoMessengerError?.();
                }
              }
              resolve({ error: true, source, id });
            },
            onFileUploadComplete(data: any, id: string) {
              const msg = {
                data: data && data[0] ? data[0].FullUrl : '',
                expts:
                  new Date().getTime() + (expts || getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS),
                photoId: -1,
                photoData: {},
              };
              if (data?.[0]) {
                if (isVideoMp4File) {
                  const videoData = mappingVideoFile(data[0].Video);
                  msg.data = { ...videoData, ownerUserId: getLoginUserId() };
                } else {
                  // As needed photoId to send notify API, and avoid break old structure message, we add field photoId here
                  msg.photoId = data[0]?.PhotoID;
                  msg.photoData = RecentlySentPhotoModel.mappingPhoto(data[0]);
                }
                // dispatch media data to shared data reducer
                const media = data.map((d: any) => ({
                  MediaType: isVideoMp4File ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.PHOTO,
                  Data: isVideoMp4File ? d?.Video : d,
                }));
                dispatch(addUserMediaSuccess(RecentlySentPhotoModel.mappingListMedia(media)));
              }
              const newMessage = parseFromLocal(chatType, toXmppId, msg, type, true, messageQuoted);
              newMessage.id = id;
              newMessage.convId = convId;
              newMessage.bySelf = true;
              newMessage.body.recvMemberLevel = recvMemberLevel;
              newMessage.body.senderMemberLevel = senderMemberLevel;
              newMessage.body.isRecvMatching = numberRecvMatching;
              newMessage.body.isSenderMatching = numberSenderMatching;
              // if (action) {
              //   action(source.uri);
              // }
              if (data && data.length > 0) {
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 100,
                    isVideoMp4File,
                    to: toXmppId,
                  })
                );
                // messageBufferAction.saveMessageToBufferStorage(newMessage);
                dispatch(replaceMessage(newMessage, type));
                if (myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
                  dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
                }
              } else {
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 0,
                    isVideoMp4File,
                    to: toXmppId,
                  })
                );
                dispatch(
                  commonStateActions.updateInAppNotificationData({
                    isFailedNotification: true,
                    errorCodeUploadImage: data.ResponseStatus ? data.ResponseStatus.ErrorCode : '',
                  })
                );
              }
              resolve(newMessage);
            },
            success(id: string) {
              // console.log("success",id);
            },
            onFileUploadProgress(process: { loaded: number; total: number }) {
              let percent = Math.ceil((process.loaded / process.total) * 100);
              console.log('-----upload image process-----', percent + '%');
              dispatch(
                updateLoading({
                  isLoading: true,
                  msgId: id,
                  percent: percent,
                  isVideoMp4File,
                  to: toXmppId,
                })
              );
            },
            accessToken,
          });
        }

        if (chatType === TYPE_GROUP_CHAT) {
          msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
        }

        WebIM.conn.send(msgObj.body);
        const pMessage = parseFromLocal(chatType, toXmppId, msgObj.body, type, true, messageQuoted);
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        pMessage.bySelf = true;
        // uri only stored in client
        pMessage.body.data = source.uri;
        pMessage.id = id;
        // console.log('pMessage', pMessage, chatType, chatId, msgObj.body);
        // if add message from local, width & height of this message will be wrong, we must add message after upload message completed
        // dispatch(addSendMessage(pMessage, type));

        pMessage.isLocalMessage = true;
        pMessage.convId = convId;
        dispatch(addSendMessage(pMessage, type));
        dispatch(
          updateLoading({
            isLoading: true,
            msgId: id,
            percent: 0,
            isVideoMp4File,
            to: toXmppId,
          })
        );
        // update unreadCount and last message for conversation
        if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
          dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
        }
      } catch (e) {
        return reject(e);
      }
    });
  };
}

export function quoteMessageBySendMedia(
  chatType = TYPE_GROUP_CHAT,
  toXmppId: string,
  source: any,
  messageQuoted: any,
  { senderMemberLevel, recvMemberLevel, isRecvMatching, isSenderMatching } = MATCHING_DEFAULT_DATA,
  { convId, expts }: { convId?: number; expts?: number } = {}
) {
  return (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      try {
        const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
        const msgQuoted = getState().messageReducer.byId[messageQuoted.id];
        if (!msgQuoted) {
          return reject(new Error('Message quoted not found'));
        }
        const id = WebIM.conn.getUniqueId();
        const msgObj = new WebIM.message(messageTypes.TYPE_QUOTE_MESSAGE, id);
        const fileName = source?.fileName || source?.filename || source?.name || '';
        const fileSize = source?.fileSize || source?.filesize || source?.size || 0;
        const accessToken = WebIM.config.rhpToken;
        const messageQuotedData = {
          type: messageQuoted.body ? messageQuoted.body.type : messageTypes.TYPE_TEXT,
          data: getDataMsgQuoted(messageQuoted),
          exptsTime: 0,
        };
        if (messageQuoted.body && messageQuoted.body.type === messageTypes.TYPE_IMAGE) {
          messageQuotedData.exptsTime = messageQuoted.expts || undefined;
        }
        const isVideoMp4File = isVideoFile(source);
        const isAudio = isAudioFile(source);
        const type = isVideoMp4File ? messageTypes.TYPE_VIDEO_FILE : isAudio ? messageTypes.TYPE_AUDIO_FILE : messageTypes.TYPE_IMAGE;
        // Implementation here
        const userVideoUploadMaxRetries = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadMaxRetries;
        const userVideoUploadPollInterval = myStore.getStore().getState().loginReducer.userInfo.client.userVideoUploadPollInterval;
        if (msgObj.set) {
          msgObj.set({
            time: getTimeSystem(chatType),
            type,
            apiUrl: WebIM.config.fileURL,
            senderMemberLevel,
            recvMemberLevel,
            isRecvMatching: numberRecvMatching,
            isSenderMatching: numberSenderMatching,
            compress: isVideoMp4File && !isNative,
            endPoint: isAudio ? urls.POST_CREATE_USER_AUDIO : isVideoMp4File ? urls.POST_CREATE_USER_VIDEO : '',
            reactOnMsgId: messageQuoted.id,
            reactOnMsgUserId: msgQuoted.user ? msgQuoted.user.userId : 0,
            reactOnMsgUsername: msgQuoted.user ? msgQuoted.user.displayName : '',
            messageQuoted: messageQuotedData,
            expts: new Date().getTime() + (expts || getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS),
            duration: source.duration || 0,
            ext: {
              file_length: fileSize,
              filename: fileName,
              filetype: fileName && fileName.split('.').pop(),
              width: source.width,
              height: source.height,
              browserUpload: source.browserUpload,
              userVideoUploadMaxRetries,
              userVideoUploadPollInterval,
            },
            file: source.browserUpload
              ? source
              : {
                  data: {
                    uri: source.uri,
                    type: isVideoMp4File ? 'video/mp4' : isAudio ? 'audio/aac' : 'application/octet-stream',
                    name: fileName,
                    size: fileSize,
                    fileData: source?.fileData,
                    timeStamp: source?.timeStamp,
                  },
                },
            to: toXmppId,
            isGroup: chatType === TYPE_GROUP_CHAT,
            roomType: '',
            onFileUploadError(error: any) {
              console.log('onFileUploadError', error);
              const isAborted = error.data?.message?.includes('Aborted');
              dispatch(
                updateLoading({
                  isLoading: false,
                  msgId: id,
                  percent: 0,
                  isVideoMp4File,
                  to: toXmppId,
                  isAudio,
                })
              );
              dispatch(removeMessageErrorSuccess(id as string));
              if (isVideoMp4File) {
                if (isAborted) {
                  WebIMConfig.onAbortUploadVideoMessenger?.();
                } else {
                  WebIMConfig.onUploadVideoMessengerError?.();
                }
              }
              resolve({ error: true, source, id });
            },
            onFileUploadComplete(data: any, id: string) {
              const msg = {
                data: data && data[0] ? data[0].FullUrl : '',
                expts:
                  new Date().getTime() + (expts || getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS),
                photoId: -1,
                photoData: {},
              };
              if (data?.[0]) {
                if (isVideoMp4File) {
                  const videoData = mappingVideoFile(data[0].Video);
                  msg.data = { ...videoData, ownerUserId: getLoginUserId() };
                } else {
                  // As needed photoId to send notify API, and avoid break old structure message, we add field photoId here
                  msg.photoId = data[0]?.PhotoID;
                  msg.photoData = RecentlySentPhotoModel.mappingPhoto(data[0]);
                }
                // dispatch media data to shared data reducer
                const media = data.map((d: any) => ({
                  MediaType: isVideoMp4File ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.PHOTO,
                  Data: isVideoMp4File ? d?.Video : d,
                }));
                dispatch(addUserMediaSuccess(RecentlySentPhotoModel.mappingListMedia(media)));
              } else if (data.fileName && isAudio) {
                msg.data = { ...data, ownerUserId: getLoginUserId() };
              }

              const newMessage = parseFromLocal(chatType, toXmppId, msg, type, true, messageQuoted);
              newMessage.id = id;
              newMessage.convId = convId;
              newMessage.bySelf = true;
              newMessage.body.recvMemberLevel = recvMemberLevel;
              newMessage.body.senderMemberLevel = senderMemberLevel;
              newMessage.body.isRecvMatching = numberRecvMatching;
              newMessage.body.isSenderMatching = numberSenderMatching;
              // if (action) {
              //   action(source.uri);
              // }
              if (data && (data.length > 0 || data.fileName)) {
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 100,
                    isVideoMp4File,
                    to: toXmppId,
                    isAudio,
                  })
                );
                // messageBufferAction.saveMessageToBufferStorage(newMessage);
                dispatch(replaceMessage(newMessage, type));
                if (!isAudio && myStore.getStore().getState().commonStateReducer.userSharedPhotos.data.length === 0) {
                  dispatch(commonStateActions.getUserSharedPhotos({ page: 1 }));
                }
              } else {
                dispatch(
                  updateLoading({
                    isLoading: false,
                    msgId: id,
                    percent: 0,
                    isVideoMp4File,
                    to: toXmppId,
                    isAudio,
                  })
                );
                dispatch(
                  commonStateActions.updateInAppNotificationData({
                    isFailedNotification: true,
                    errorCodeUploadImage: data.ResponseStatus ? data.ResponseStatus.ErrorCode : '',
                  })
                );
              }
              resolve(newMessage);
            },
            success(id: string) {
              // console.log("success",id);
            },
            onFileUploadProgress(process: { loaded: number; total: number }) {
              let percent = Math.ceil((process.loaded / process.total) * 100);
              console.log('-----upload image process-----', percent + '%');
              dispatch(
                updateLoading({
                  isLoading: true,
                  msgId: id,
                  percent: percent,
                  isVideoMp4File,
                  to: toXmppId,
                  isAudio,
                })
              );
            },
            accessToken,
          });
        }

        if (chatType === TYPE_GROUP_CHAT) {
          msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
        }

        WebIM.conn.send(msgObj.body);
        const pMessage = parseFromLocal(chatType, toXmppId, msgObj.body, type, true, messageQuoted);
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        pMessage.bySelf = true;
        // uri only stored in client
        pMessage.body.data = source.uri;
        pMessage.id = id;
        // console.log('pMessage', pMessage, chatType, chatId, msgObj.body);
        // if add message from local, width & height of this message will be wrong, we must add message after upload message completed
        // dispatch(addSendMessage(pMessage, type));

        pMessage.isLocalMessage = true;
        pMessage.convId = convId;
        dispatch(addSendMessage(pMessage, type));
        dispatch(
          updateLoading({
            isLoading: true,
            msgId: id,
            percent: 0,
            isVideoMp4File,
            to: toXmppId,
          })
        );
        // update unreadCount and last message for conversation
        if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
          dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
        }
      } catch (e) {
        return reject(e);
      }
    });
  };
}

interface QuoteMessageParams {
  chatType: string;
  toXmppId: string;
  message: any;
  messageQuoted: any;
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  options?: { convId?: number | null };
}

export function quoteMessage(
  chatType = TYPE_GROUP_CHAT,
  toXmppId: string,
  message: any,
  messageQuoted: any,
  { senderMemberLevel, recvMemberLevel, isRecvMatching, isSenderMatching } = MATCHING_DEFAULT_DATA,
  { convId, expts }: { convId?: number; expts?: number } = {}
) {
  return (dispatch: any, getState: any) => {
    try {
      const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const msgQuoted = getState().messageReducer.byId[messageQuoted.id];
      if (!msgQuoted) {
        return Promise.reject(new Error('Message quoted not found'));
      }
      if (message?.bodyType === messageTypes.TYPE_IMAGE || message?.bodyType === messageTypes.TYPE_VIDEO_FILE) {
        message.expts =
          new Date().getTime() + (expts || getState().loginReducer.userInfo.messenger.defaultImageDuration.value || THREE_MONTHS);
      }
      const pMessage = parseFromLocal(chatType, toXmppId, message, message.bodyType, true, messageQuoted);
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      if (message.photoId) {
        pMessage.body.photoId = message.photoId;
      }
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(messageTypes.TYPE_QUOTE_MESSAGE, id);
      const messageQuotedData = {
        type: messageQuoted.body ? messageQuoted.body.type : messageTypes.TYPE_TEXT,
        data: getDataMsgQuoted(messageQuoted),
        galleryName: '',
        exptsTime: 0,
      };

      if (messageQuoted.body?.type === TYPE_GALLERY) {
        messageQuotedData.galleryName = messageQuoted.body?.data?.name || '';
      }

      if (
        messageQuoted.body &&
        (messageQuoted.body.type === messageTypes.TYPE_IMAGE || messageQuoted.body.type === messageTypes.TYPE_VIDEO_FILE)
      ) {
        messageQuotedData.exptsTime = messageQuoted.expts || undefined;
      }
      const user = msgQuoted.user?.userId ? msgQuoted.user : messageQuoted.user;
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data: {
            type,
            data,
            expts: message.expts,
            senderMemberLevel,
            recvMemberLevel,
            isRecvMatching: numberRecvMatching,
            isSenderMatching: numberSenderMatching,
          },
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          to,
          reactOnMsgId: messageQuoted.id,
          reactOnMsgUserId: user?.userId || 0,
          reactOnMsgUsername: user?.displayName || '',
          messageQuoted: messageQuotedData,
          expts: message.expts,
        });
      }

      if (chatType === 'groupchat') {
        msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
      }
      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      dispatch(addSendMessage(pMessage, chatType));
      if (chatType !== TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }
      return Promise.resolve(pMessage);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

export function isMediaMessage(msgType: string): boolean {
  return ([messageTypes.TYPE_IMAGE, messageTypes.TYPE_VIDEO_FILE] as string[]).includes(msgType);
}

function getDataMsgQuoted(message: any): any {
  switch (message?.body?.type) {
    case messageTypes.TYPE_GIF:
      return message?.body?.data?.fixedWidth;
    case messageTypes.TYPE_IMAGE:
      return message?.body?.data;
    case messageTypes.TYPE_VIDEO_FILE:
      return message?.body?.data?.thumbUrl;
    case messageTypes.TYPE_AUDIO_FILE:
      return message?.body?.data?.duration;
    case messageTypes.TYPE_GALLERY:
      return message?.body?.data?.galleryId;
    default:
      return message?.body?.data;
  }
}

interface DeleteInvitedGroupChatMsgParams {
  userId: number;
  from: string;
  roomJid: string;
}

export function deleteInvitedGroupChatMsg({ userId, from, roomJid }: DeleteInvitedGroupChatMsgParams) {
  return (dispatch: any) => {
    return messageApi
      .lookUpMessageByCondition({
        receiverXmppId: addPrefixAndSuffix(userId),
        msgMetaData: roomJid,
        msgType: messageTypes.TYPE_INVITE_GROUP_CHAT,
      })
      .then(res => {
        if (res.success && res.data && res.data?.items?.length > 0) {
          let deleteMsgIds = res.data?.items;
          deleteMsgIds.forEach((deleteMsgId: string) => {
            if (deleteMsgId) {
              let deleteMsg = {
                id: deleteMsgId,
                type: TYPE_CHAT,
                bySelf: true,
                to: userId.toString(),
                from,
              };
              return dispatch(conversationDetailAction.deleteMessage(deleteMsg, true, false));
            }
          });
        }
      });
  };
}

interface SendRemovedFromGroupMessageParams {
  chatType: string;
  chatId: string;
  messageData: { userId: number; value?: string };
  msgId?: string;
  options?: { convId?: number | null };
}

export function sendRemovedFromGroupMessage({
  chatType = CHAT_TYPES.GROUP_CHAT,
  chatId,
  messageData = { userId: -1, value: '' },
  msgId,
  options: { convId } = { convId: null },
}: SendRemovedFromGroupMessageParams) {
  return (dispatch: any) => {
    try {
      if (!messageData?.userId) {
        return Promise.reject(new Error('User ID not found'));
      }
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: messageData,
        },
        messageTypes.TYPE_REMOVED_FROM_GROUP,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
        });
      }
      msgObj.setGroup(TYPE_GROUP_CHAT);

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      // messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }
      dispatch(
        deleteInvitedGroupChatMsg({
          userId: messageData.userId,
          from: pMessage.from,
          roomJid: chatId,
        })
      );
      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  };
}

interface SendLeaveGroupMessageParams {
  chatType?: string;
  messageType?: string;
  chatId: string;
  messageData?: { userId: number; value?: string };
  msgId?: string;
  options?: { convId?: number | null };
}

export function sendLeaveGroupMessage({
  chatType = CHAT_TYPES.GROUP_CHAT,
  messageType = messageTypes.TYPE_LEAVE_GROUP_CHAT,
  chatId,
  messageData = { userId: -1, value: '' },
  msgId,
  options: { convId } = { convId: null },
}: SendLeaveGroupMessageParams) {
  return (dispatch: any) => {
    try {
      if (!messageData?.userId) {
        console.error('Data message require field userId!');
        return Promise.reject('Data message require field userId!');
      }
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: messageData,
        },
        messageTypes.TYPE_LEAVE_GROUP_CHAT,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
        });
      }
      msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      // messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}

interface SendInviteGroupChatMessageParams {
  chatType?: string;
  chatId: string;
  group: any;
  senderMemberLevel: number;
  recvMemberLevel: number;
  isRecvMatching: boolean;
  isSenderMatching: boolean;
  msgId?: string;
  expts?: any;
  options?: { convId?: number | null; notificationType: NotificationType };
}

/**
 * Edit a text message.
 *
 * This function edits a text message by dispatching an action to update the message.
 * It creates a new message object with the updated data and sends it using WebIM.
 *
 * @param {Object} params - The parameters for editing the text message.
 * @param {string} params.chatType - The type of chat (e.g., group chat or individual chat).
 * @param {string} params.chatId - The ID of the chat.
 * @param {string} params.data - The new data for the message - text data type string.
 * @param {string} params.msgId - The ID of the message to be edited.
 * @param {Object} params.group - The group information. {
 *                                  groupId: number,
 *                                  value: I18n.t('UserNameHasInvitedYouToTheGroupGroupName', {
 *                   userName: selectedPeerVcard.displayName,
 *                   groupName: data.clubName,
 *                 })
 *                 }
 * @param {string} params.group.id - The ID of the group.
 * @param {string} params.group.value - The invitation message for the group.
 * @returns {Function} A function that takes dispatch as an argument and returns a promise.
 */
export function sendInviteGroupMessage({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  group,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  expts,
  options: { convId, notificationType } = { convId: null, notificationType: TYPE_INVITE },
}: SendInviteGroupChatMessageParams) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = 1;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: group,
        },
        messageTypes.TYPE_INVITE_GROUP,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.notificationType = notificationType;
      pMessage.expts = expts;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          expts,
        });
      }
      console.log('msg', msgObj.body);
      WebIM.conn.send(msgObj.body);

      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}

export function sendInviteGroupChatMessage({
  chatType = CHAT_TYPES.CHAT,
  chatId,
  group,
  senderMemberLevel,
  recvMemberLevel,
  isRecvMatching,
  isSenderMatching,
  msgId,
  expts,
  options: { convId, notificationType } = { convId: null, notificationType: TYPE_INVITE },
}: SendInviteGroupChatMessageParams) {
  return (dispatch: any) => {
    try {
      const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: group,
        },
        messageTypes.TYPE_INVITE_GROUP_CHAT,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      pMessage.body.recvMemberLevel = recvMemberLevel;
      pMessage.body.senderMemberLevel = senderMemberLevel;
      pMessage.body.isRecvMatching = numberRecvMatching;
      pMessage.body.isSenderMatching = numberSenderMatching;
      pMessage.notificationType = notificationType;
      pMessage.expts = expts;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
          senderMemberLevel,
          recvMemberLevel,
          isRecvMatching: numberRecvMatching,
          isSenderMatching: numberSenderMatching,
          expts,
        });
      }

      WebIM.conn.send(msgObj.body);

      pMessage.convId = convId;
      // Add message to buffer storage
      messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}

interface SendJoinedGroupMessageParams {
  chatType?: string;
  messageType?: keyof typeof msgTpl;
  chatId: string;
  messageData?: { userId: number; value?: string };
  msgId?: string;
  options?: { convId?: number | null };
}

export function sendJoinedGroupMessage({
  chatType = CHAT_TYPES.GROUP_CHAT,
  messageType = messageTypes.TYPE_JOINED_GROUP_CHAT,
  chatId,
  messageData = { userId: -1 },
  msgId,
  options: { convId } = { convId: null },
}: SendJoinedGroupMessageParams) {
  return (dispatch: any) => {
    try {
      if (!messageData?.userId) {
        console.error('Data message require field userId!');
        return Promise.reject('Data message require field userId!');
      }
      const pMessage = parseFromLocal(
        chatType,
        chatId,
        {
          data: messageData,
        },
        messageTypes.TYPE_JOINED_GROUP_CHAT,
        true,
        undefined,
        msgId
      );
      pMessage.bySelf = true;
      const { body, id, to } = pMessage;
      const { type, data } = body;
      const msgObj = new WebIM.message(type, id);
      if (msgObj.set) {
        msgObj.set({
          time: pMessage.time,
          data,
          to,
        });
      }
      msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);

      WebIM.conn.send(msgObj.body);
      pMessage.convId = convId;
      // Add message to buffer storage
      // messageBufferAction.saveMessageToBufferStorage(pMessage);
      dispatch(addSendMessage(pMessage, type));
      if (chatType !== chatTypes.TYPE_GROUP_CHAT) {
        dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
      }

      return Promise.resolve(pMessage);
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}
interface RemoveMessageShareEventTicketParams {
  userId: number;
  eventId: string;
}

export function removeMessageShareEventTicket({ userId, eventId }: RemoveMessageShareEventTicketParams) {
  return (dispatch: any) => {
    const userInfo = myStore.getStore().getState().loginReducer.userInfo;
    return messageApi
      .lookUpMessageByCondition({
        receiverXmppId: addPrefixAndSuffix(userId),
        msgMetaData: eventId,
        msgType: TYPE_SHARE_EVENT_TICKET,
      })
      .then((res: any) => {
        if (res.success && res.data && res.data?.items?.length > 0) {
          let deleteMsgIds = res.data?.items;
          deleteMsgIds.forEach((deleteMsgId: string) => {
            if (deleteMsgId) {
              let deleteMsg = {
                id: deleteMsgId,
                type: TYPE_CHAT,
                bySelf: true,
                to: userId.toString(),
                from: userInfo.userId,
              };
              return dispatch(conversationDetailAction.deleteMessage(deleteMsg, true, false));
            }
          });
        }
      });
  };
}

export function updateTxtMessageSuccess(message: IMessage, type: string) {
  return {
    type: types.CHAT_EDIT_TEXT_MESSAGE_SUCCESS,
    message: message,
    bodyType: type,
  };
}

/**
 * Edit a text message.
 *
 * This function edits a text message by dispatching an action to update the message.
 * It creates a new message object with the updated data and sends it using WebIM.
 *
 * @param {Object} params - The parameters for editing the text message.
 * @param {string} params.chatType - The type of chat (e.g., group chat or individual chat).
 * @param {string} params.chatId - The ID of the chat.
 * @param {string} params.data - The new data for the message - text data type string.
 * @param {string} params.msgId - The ID of the message to be edited.
 * @returns {Function} A function that takes dispatch as an argument and returns a promise.
 */
// export function editTxtMessage({ chatType, chatId, data, msgId }: EditTextMessageParams) {
export function editTxtMessage({ chatType, chatId, data, msgId, options: { isLastedMessage, convId } }: EditTextMessageParams) {
  return (dispatch: any) => {
    try {
      const _message = { data };
      const pMessage = parseFromLocal(chatType, chatId, _message, messageTypes.TYPE_FASTEN_EDIT, true, undefined, msgId);
      pMessage.edited = true;
      const {
        body: { type },
        id,
        to,
      } = pMessage;

      return messageApi
        .patchEditMessage(msgId, {
          chatType: chatType,
          convId,
          data: { text: data },
          isLastMessage: isLastedMessage,
          toJid: addPrefixAndSuffix(pMessage.to),
          // fromJid: addPrefixAndSuffix(pMessage.from),
        })
        .then((res: any) => {
          const msgObj = new WebIM.message(type, id);

          if (msgObj.set) {
            msgObj.set({
              data,
              to,
              storeMessageByTigase: false,
            });
          }

          if (chatType === 'groupchat') {
            msgObj.setGroup(chatTypes.TYPE_GROUP_CHAT);
          }
          WebIM.conn.send(msgObj.body);
          dispatch(updateTxtMessageSuccess(pMessage, type));
          dispatch(selectMessage(''));
          return Promise.resolve(pMessage);
        });
    } catch (e) {
      console.log(e);
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(e);
    }
  };
}
